import React from 'react';
import './AboutUs.css'
import { Helmet } from 'react-helmet';

const AboutUs = () => {
  return (
    <div className='au-box'>
      <Helmet>
        <title>Veegana - About Us</title>
      </Helmet>
      <h2>About Us</h2>
      <p>Welcome to Veegana, your ultimate destination for vegetarian recipes! Veegana is dedicated to providing a wide array of delicious plant-based dishes. Whether you're looking for hearty mains, nutritious salads, or delightful desserts, Veegana offers a variety of recipes to suit every taste. Join us in celebrating the flavors and benefits of vegetarian cuisine, and discover how easy and enjoyable it can be to incorporate more plant-based meals into your lifestyle with Veegana.</p>
      {}
    </div>
  );
};

export default AboutUs;